import { useState } from "react";
import { useDebounce } from "react-use";
import classNames from "classnames";
import style from "./search-field.module.css";

interface SearchFieldProps extends React.HTMLProps<HTMLInputElement> {
  searchValue: string;
  setSearchValue: (value: string) => void;
  id?: string;
  name?: string;
  placeholder?: string;
  enabled?: boolean;
  className?: string;
}

export function SearchField(props: SearchFieldProps) {
  const { searchValue, setSearchValue, enabled = true, className, ...rest } = props;
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={classNames(style.search, className)}>
      <input
        id={props.id}
        name={props.name}
        type={"search"}
        placeholder={props.placeholder ?? "Search"}
        {...rest}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value.trimStart())}
        disabled={!enabled}
      />
    </label>
  );
}

interface DebouncedSearchFieldProps extends SearchFieldProps {
  ms?: number;
}

export function DebouncedSearchField(props: DebouncedSearchFieldProps) {
  const { searchValue, setSearchValue, ms = 500, ...rest } = props;
  const [value, setValue] = useState(searchValue);
  useDebounce(() => setSearchValue(value), ms, [value]);

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={style.search}>
      <input
        type={"text"}
        placeholder={props.placeholder ?? "Search"}
        id={props.id}
        name={props.name}
        {...rest}
        value={value}
        onChange={(e) => setValue(e.target.value.trimStart())}
      />
    </label>
  );
}
